<template>
  <div class="Login">
    <form>
      <md-layout md-align="center" md-gutter="24">
        <md-layout md-flex-xsmall="70" md-flex-small="40" md-flex-medium="35" md-flex-large="30" md-flex-xlarge="20">
          <md-input-container>
            <label>Usuario</label>
            <md-input v-model="u" @keyup.native.enter="hacerLogin" required/>
          </md-input-container>
          <md-input-container md-has-password>
            <label>Contraseña</label>
            <md-input v-model="p" @keyup.native.enter="hacerLogin" type="password" required/>
          </md-input-container>
          <md-button class="md-raised md-accent" @click.native="hacerLogin">Iniciar sesión</md-button>
        </md-layout>
      </md-layout>
    </form>
  </div>
</template>
<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
  name: "Login",
  beforeCreate() {
    this.$session.destroy();
  },
  created() {
    this.$session.destroy();
  },
  methods: {
    hacerLogin() {
      this.$http
        .post("sesion/login", {
          u: sha1(md5(this.u)),
          p: sha1(md5(this.p))
        })
        .then(
          response => {
            if (response.status === 200 && "usuario" in response.body) {
              this.$session.destroy();
              this.$session.start();
              this.$session.set("token", response.body.usuario.token),
                this.$session.set("nombre", response.body.usuario.nombre),
                this.$session.set("tipo", response.body.usuario.tipo),
                Snackbar.show({
                  text: "BIENVENIDO " + response.body.usuario.nombre,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false
                });
              this.$router.push("/");
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo hacer conexión",
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    }
  },
  data() {
    return {
      u: null,
      p: null
    };
  }
};
</script>



// WEBPACK FOOTER //
// Login.vue?6d13047e